const productPayment = {
    successTitle: 'Pagamento completato!',
    successMessage: 'Il tuo ordine è stato ricevuto e confermato',
    nextSteps: 'Prossimi passi',
    emailConfirmation: 'Riceverai una email di conferma',
    orderProcessing: 'Il tuo ordine è in elaborazione',
    shippingUpdate: 'Riceverai aggiornamenti sulla spedizione',
    viewOrders: 'Visualizza ordini',
    continueShopping: 'Continua lo shopping',
    questions: 'Domande?',
    contactUs: 'Contattaci',
    cancelledTitle: 'Pagamento annullato',
    cancelledMessage: 'Il tuo pagamento è stato annullato',
    whatHappened: 'Cosa è successo?',
    noCharge: 'Non è stato addebitato alcun importo',
    cartPreserved: 'I tuoi prodotti sono ancora nel carrello',
    tryAgain: 'Riprova',
    returnToCart: 'Torna al carrello',
    needHelp: 'Hai bisogno di aiuto?'
};

export default productPayment;
